import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-404" }
const _hoisted_2 = { class: "container-404__title" }
const _hoisted_3 = { class: "container-404__content" }
const _hoisted_4 = { class: "container-404__title" }
const _hoisted_5 = { class: "container-404__text" }

import { useRouter } from 'vue-router';

import AppHeader from '@exchange/layouts/app-header/AppHeader.vue';
import HeaderMobile from '@exchange/layouts/app-header/HeaderMobile.vue';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

import InfoTile from './components/InfoTile.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Container404Page',
  setup(__props) {

const router = useRouter();
const { isXS } = useMQBreakpoints();

const goBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isXS))
      ? (_openBlock(), _createBlock(HeaderMobile, {
          key: 0,
          onGoBack: goBack
        }, {
          "top-content": _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('views.404.name')), 1)
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(AppHeader, { key: 1 })),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(InfoTile, { class: "container-404__info" }, _createSlots({
        text: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('views.404.description')), 1)
        ]),
        _: 2
      }, [
        (!_unref(isXS))
          ? {
              name: "title",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('views.404.name')), 1)
              ]),
              key: "0"
            }
          : undefined
      ]), 1024),
      _createVNode(_component_x_button, {
        class: "container-404__go-back",
        variant: "primary",
        text: _ctx.$t('views.404.goBack'),
        onClick: goBack
      }, null, 8, ["text"])
    ])
  ]))
}
}

})